import { render, staticRenderFns } from "./StudentListSettingsForm.vue?vue&type=template&id=4f2dce22"
import script from "./StudentListSettingsForm.vue?vue&type=script&lang=js"
export * from "./StudentListSettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports